import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrossLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCrossLarge"><Path fillRule="evenodd" clipRule="evenodd" d="M5.00001 3.23242L12 10.2324L19 3.23242L20.7678 5.00019L13.7678 12.0002L20.7678 19.0002L19 20.768L12 13.768L5.00001 20.768L3.23224 19.0002L10.2322 12.0002L3.23224 5.00019L5.00001 3.23242Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrossLarge;
